const localeAliases: Record<string, string> = {
  ca_es: 'ca-es'
};

export function normalizeLocale(locale?: string | null): string | undefined {
  if (typeof locale !== 'string') {
    return;
  }

  const normalizedLocale = locale.toLowerCase();

  return localeAliases[normalizedLocale] || normalizedLocale;
}

export function normalizeLocales(
  locales?: Array<string | null | undefined> | null
): string[] | null | undefined {
  if (!locales) {
    return locales;
  }

  return Array.from(
    new Set(
      locales
        .map(locale => normalizeLocale(locale))
        .filter((locale): locale is string => Boolean(locale))
    )
  );
}

export function normalizeSystemLocales<
  T extends {
    defaultLanguageCode?: string | null;
    languageCodes?: Array<string | null | undefined> | null;
  }
>(system?: T | null): T | undefined {
  if (!system) {
    return;
  }

  return {
    ...system,
    defaultLanguageCode:
      normalizeLocale(system.defaultLanguageCode) || system.defaultLanguageCode,
    languageCodes:
      normalizeLocales(system.languageCodes) || system.languageCodes
  };
}
